var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcStatesMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.47492C14 8.06052 11.3137 9.34591 8 9.34591C4.68629 9.34591 2 8.06052 2 6.47492C2 6.38692 2.00827 6.29985 2.02447 6.21387H2V6.47492L2 10.1289V10.3899H2.02445C2.29999 11.8532 4.87013 12.9999 8 12.9999C11.1299 12.9999 13.7 11.8532 13.9755 10.3899H14V10.1289V6.47492ZM13.9755 6.21387H14V6.47492C14 6.38692 13.9917 6.29985 13.9755 6.21387Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.3416C11.3137 9.3416 14 8.05621 14 6.4706C14 4.885 11.3137 3.59961 8 3.59961C4.68629 3.59961 2 4.885 2 6.4706C2 8.05621 4.68629 9.3416 8 9.3416Z",
    fill: "#0A0A0A",
    stroke: "#FCFCFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatesMoney);
export default __webpack_public_path__ + "static/media/ic_states_money.9e8eef2ae3781ee12944fd85fa8cfa76.svg";
export { ForwardRef as ReactComponent };